import { render, staticRenderFns } from "./EventModalPassesAddForm.vue?vue&type=template&id=fedc4120"
import script from "./EventModalPassesAddForm.vue?vue&type=script&lang=js"
export * from "./EventModalPassesAddForm.vue?vue&type=script&lang=js"
import style0 from "./EventModalPassesAddForm.vue?vue&type=style&index=0&id=fedc4120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports